module.exports = __webpack_public_path__ + "static/img/show_pic3.c4c1ef78.png";